module.exports = __webpack_public_path__ + "img/as.093b6bc3.svg";